import { render, staticRenderFns } from "./DownloadItem.vue?vue&type=template&id=70cee834&scoped=true&"
import script from "./DownloadItem.vue?vue&type=script&lang=ts&"
export * from "./DownloadItem.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadItem.vue?vue&type=style&index=0&id=70cee834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cee834",
  null
  
)

export default component.exports